import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon } from '@artprov/design-system';
import PropTypes from 'prop-types';

/**
 * Componente memoizado para la celda de acciones (ver detalle).
 * Evita re-crear JSX y funciones en cada render del padre.
 */
export const AccionesCell = memo(function AccionesCell({ id }) {
    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        navigate(`/matching-bancario/${id}`);
    }, [navigate, id]);

    const handleKeyUp = useCallback((e) => {
        if (e.key === 'Enter') {
            navigate(`/matching-bancario/${id}`);
        }
    }, [navigate, id]);

    return (
        <Button iconOnly
            aria-label="Ver más"
            variant="ghost"
            size="xs"
            onClick={handleClick}
            onKeyUp={handleKeyUp}
            startIcon={<Icon icon="visibility" size="small" />
            }
        />
    );
});

AccionesCell.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
